import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import { Row, Col, Nav, Table, FormControl, FormGroup, ControlLabel, Content, Checkbox, Button } from 'react-bootstrap';
import TimelistWorkflowStepLineItemStore from './timeline-workflow-step-lineitem-store';

@inject('appStore')
@observer
export default class TimelineWorkflowStepLineitem extends Component {
    constructor(props) {
        super(props);
        this.timelineStepStore = new TimelistWorkflowStepLineItemStore(
            props.eventInstance.exclude,
            props.eventInstance.excludeFromWorkflow,
            props.eventInstance.excludeFromEmailGrid,
            props.eventInstance.excludeFromCalendarReminders,
            props.eventInstance.days,
            props.eventInstance.name,
            props.eventInstance.timelineEventId,
            props.setDays,
            props.setExclude,
            props.setName,
            props.setExcludeFromWorkflow,
            props.setExcludeFromEmailGrid,
            props.setExcludeFromCalendarReminders
        );
    }

    componentWillReceiveProps(props) {
        if (props.eventInstance.exclude != this.timelineStepStore.exclude) {
            this.timelineStepStore.updateExclude(props.eventInstance.exclude);
        }
        if (props.eventInstance.days != this.timelineStepStore.deadlineDays) {
            this.timelineStepStore.updateDeadlineDays(props.eventInstance.days);
        }
    }

    formatDeadLine(date, checked, days) {
        if (checked) return <div className="excluded">Excluded</div>;

        if (days !== 0 && !days) return '';

        return date ? date.format('ddd, MMM D, YYYY') : null;
    }

    formatDateShift(count, type, exclude) {
        if (count > 0 && !exclude) {
            return <div>{`Shifted ${count} day${count > 1 ? 's' : ''} for ${type}`}</div>;
        }
    }

    @action
    handleRemove() {
        appStore.workflowStore.timelineWorkflowStore.removeTimelineEvent(this.timelineStepStore.eventId);
    }

    render() {
        const { eventInstance, connectDragSource, connectDragPreview, isDragging } = this.props;

        return connectDragPreview(
            <div style={{ minHeight: 38, marginTop: 5 }}>
                <Row>
                    <Col xs={4}>
                        <Row>
                            {connectDragSource(
                                <div className={'drag-handle'}>
                                    <Col xs={2}>
                                        <i style={{ marginTop: 9, marginLeft: 8 }} className="fa fa-lg fa-bars" />
                                    </Col>
                                </div>
                            )}

                            <Col xs={10}>
                                <FormControl
                                    className="input-sm"
                                    type="text"
                                    inputRef={ref => {
                                        this.nameInput = ref;
                                    }}
                                    disabled={this.timelineStepStore.exclude}
                                    value={this.timelineStepStore.name}
                                    onChange={e => {
                                        this.timelineStepStore.updateName(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={1}>
                        <FormControl
                            className="input-sm"
                            type="text"
                            inputRef={ref => {
                                this.daysInput = ref;
                            }}
                            disabled={this.timelineStepStore.exclude}
                            value={this.timelineStepStore.deadlineDays}
                            onChange={e => {
                                this.timelineStepStore.updateDeadlineDays(e.target.value);
                            }}
                        />
                    </Col>
                    <Col xs={3}>
                        {this.formatDeadLine(
                            eventInstance.deadlineCalculated,
                            eventInstance.exclude,
                            eventInstance.days
                        )}
                        {/* TODO const this */}
                        {this.formatDateShift(eventInstance.weekendDateShift, 'weekend', eventInstance.exclude)}
                        {this.formatDateShift(eventInstance.holidayDateShift, 'holiday', eventInstance.exclude)}
                    </Col>
                    <Col xs={3}>
                        <Row>
                            <Col xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                                {eventInstance.custom ? null : (
                                    <Checkbox
                                        checked={this.timelineStepStore.excludeFromWorkflow}
                                        disabled={this.timelineStepStore.excludeFromWorkflowDisabled}
                                        onChange={e => {
                                            this.timelineStepStore.updateExcludeFromWorkflow(e.target.checked);
                                        }}
                                    ></Checkbox>
                                )}
                            </Col>
                            <Col xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Checkbox
                                    disabled={this.timelineStepStore.excludeFromCalendarRemindersDisabled}
                                    checked={this.timelineStepStore.excludeFromCalendarReminders}
                                    onChange={e => {
                                        this.timelineStepStore.updateExcludeFromCalendarReminders(e.target.checked);
                                    }}
                                ></Checkbox>
                            </Col>
                            <Col xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Checkbox
                                    checked={this.timelineStepStore.excludeFromEmailGrid}
                                    onChange={e => {
                                        this.timelineStepStore.updateExcludeFromEmailGrid(e.target.checked);
                                    }}
                                ></Checkbox>
                            </Col>
                            <Col xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Checkbox
                                    checked={this.timelineStepStore.exclude}
                                    onChange={e => {
                                        this.timelineStepStore.updateExclude(e.target.checked);
                                    }}
                                ></Checkbox>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={1} style={{ display: 'flex', justifyContent: 'center' }}>
                        {eventInstance.custom ? (
                            <Button
                                className="input-sm"
                                style={{ marginBottom: '15px' }}
                                onClick={this.handleRemove.bind(this)}
                            >
                                <span className={`fa fa-minus`} />
                            </Button>
                        ) : null}
                    </Col>
                </Row>
                <Row>
                    <Col xs={4}>
                        <Row>
                            <Col xs={2}></Col>
                            <Col xs={10}>
                                {!this.timelineStepStore.exclude && this.timelineStepStore.nameIsInvalid ? (
                                    <p className="form-error" style={{ fontSize: 12 }}>
                                        Please enter event/reminder name
                                    </p>
                                ) : null}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={8} style={{ paddingLeft: 5 }}>
                        {!this.timelineStepStore.exclude && this.timelineStepStore.deadlineDaysIsInvalid ? (
                            <p className="form-error" style={{ fontSize: 12 }}>
                                Please enter number of days
                            </p>
                        ) : null}
                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/timeline/timeline-workflow-step-lineitem.js